import { AuthSignInForm } from '@command-center/ui-system';
import { useAuth } from './AuthProvider';

export function SignInForm() {
  const { signIn, isConfigured, requestPasswordReset } = useAuth();

  return (
    <AuthSignInForm
      description="Use the email address One Up invited you with."
      configured={isConfigured}
      configurationMessage="Sign-in is temporarily unavailable. Please contact One Up and we’ll get you in."
      onSignIn={signIn}
      onForgotPassword={requestPasswordReset}
    />
  );
}
